import { IMessageConverter, IMessageData } from '@uxdf/direct-shared-lib';
import { Injectable } from '@angular/core';
import { BookService } from './book.service';

@Injectable()
export class BookMessageConverter implements IMessageConverter {
  private iFrameOrigin: string;

  constructor(private readonly bookService: BookService) {
    this.bookService.getServiceUrl().subscribe(url => (this.iFrameOrigin = url));
  }

  execute(e: MessageEvent): IMessageData {
    if (e.origin === this.iFrameOrigin) {
      try {
        const msg = JSON.parse(e.data);
        return { type: msg.type, data: msg.data };
      } catch (_) {
        /* tslint:disable:no-empty */
      }
    }
  }
}
